import errorModule from 'src/js/modules/error';
import { serviceProvider } from '@yola/subscription-manager-js';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const cancelSubscription = (subscriptionId, reason) => async (dispatch) => {
  dispatch(status.actions.setStatus(statusNames.CANCEL_SUBSCRIPTION, status.constants.LOADING));

  try {
    await serviceProvider.cancelSubscription(subscriptionId, reason);
    dispatch(status.actions.setStatus(statusNames.CANCEL_SUBSCRIPTION, status.constants.SUCCEEDED));
  } catch (error) {
    errorModule.operations.catchError(error);
    console.error(error);
    dispatch(status.actions.setStatus(statusNames.CANCEL_SUBSCRIPTION, status.constants.FAILED));

    throw error;
  }
};

export default cancelSubscription;
